var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-page-wrapper',{staticClass:"employee-method-list",attrs:{"title":"Способы выплат","settings-title":"Способы выплат","error-text":"Способы выплат не загружены","filters":_vm.filters,"filters-wax-width":400,"is-group-by":true,"table-options":_vm.table,"create-form":_vm.createMethodForm,"is-hide-cols":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }